import "./App.css";
import { Switch, Route, Redirect } from "react-router-dom";
import Home from "./pages";
import SigninPage from "./pages/signin";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { isAndroid, isDesktop, isIOS } from "react-device-detect";
import { DotLoader } from "react-spinners";

import { LanguageProvider } from "./contexts/LanguageContext";
import { GeolocationProvider } from "./contexts/GeolocationContext"; // Import the GeolocationProvider
import { DocumentRenderer } from "./components/DocumentRenderer"; // Import the DocumentRenderer component
import GeoRedirectWrapper from "./components/GeoRedirectWrapper"; // Import the GeoRedirectWrapper component

// Document Redirector component to handle country-specific document paths
const DocumentRedirector = ({ match, ...props }) => {
  const { documentName } = match.params;
  const defaultCountry = "ke"; // Default country (Kenya)

  // List of valid country codes - these should NOT be treated as documents
  const validCountryCodes = ["ke", "tz", "ug", "ng", "gh", "za", "cm"];

  // Normalize document name (remove .pdf extension, convert to lowercase)
  const normalizedDocName = documentName.toLowerCase().replace(/\.pdf$/, "");

  // Check if the "documentName" is actually a country code
  if (validCountryCodes.includes(normalizedDocName)) {
    return null; // Don't redirect country codes
  }

  // Special case mappings for specific documents
  const documentCountryMap = {
    britam: "ke",
    britamtz: "tz",
    // Add future document mappings here as needed
  };

  // Find the appropriate country for this document
  let targetCountry = defaultCountry;

  // Check for country-specific document
  if (documentCountryMap[normalizedDocName]) {
    targetCountry = documentCountryMap[normalizedDocName];
  }

  // For documents with country suffix like "britamtz", "kenyainsurance", etc.
  // This is a fallback for documents that aren't explicitly mapped
  for (const countryCode of validCountryCodes) {
    if (normalizedDocName.endsWith(countryCode)) {
      // If document ends with country code, use that country
      // Example: britamtz -> tz, insuranceug -> ug
      targetCountry = countryCode;
      break;
    }
  }

  // Redirect to the country-specific document path
  return <Redirect to={`/${targetCountry}/${normalizedDocName}`} />;
};

function App() {
  return (
    <GeolocationProvider>
      <GeoRedirectWrapper>
        <LanguageProvider>
          <Switch>
        {/* Keep existing non-document routes */}
        <Route exact path="/" component={Home} />
        <Route exact path="/contactUs" component={SigninPage} />
        <Route
          path="/littledriver"
          component={() => {
            if (isAndroid) {
              window.location.href =
                "https://play.google.com/store/apps/details?id=com.craftsilicon.littlecabdriver";
            }
            if (isIOS) {
              window.location.href =
                "https://apps.apple.com/ke/app/little-agent/id1547421613";
            }
            if (isDesktop) {
              window.location.href = "https://apps.little.africa";
            }
            return (
              <div
                style={{
                  marginTop: "170px",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  flexDirection: "column",
                }}
              >
                <DotLoader color={"#000000"} loading={true} size={50} />
                <br />
                <br />
                <span
                  style={{
                    fontFamily: "Helvetica, sans-serif",
                    color: "#353232",
                    width: "50%",
                    lineHeight: "1.5",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#353232",
                      fontSize: "20px",
                      textAlign: "center",
                    }}
                  >
                    your
                  </span>
                  <br />
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#00ba75",
                      fontSize: "20px",
                    }}
                  >
                    kila
                  </span>
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#008ad0",
                      fontSize: "20px",
                    }}
                  >
                    day
                  </span>
                  .
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#FF0000",
                      fontSize: "20px",
                    }}
                  >
                    every
                  </span>
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#FF0000",
                      fontSize: "20px",
                    }}
                  >
                    thing
                  </span>
                  . app!
                  <br />
                  <br />
                </span>
              </div>
            );
          }}
        />
        <Route
          path="/littlerider"
          component={() => {
            if (isAndroid) {
              window.location.href =
                "https://play.google.com/store/apps/details?id=com.craftsilicon.littlecabrider";
            }
            if (isIOS) {
              window.location.href =
                "https://apps.apple.com/ke/app/little-ride/id1130691846";
            }
            if (isDesktop) {
              window.location.href = "https://apps.little.africa";
            }
            return (
              <div
                style={{
                  marginTop: "170px",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  flexDirection: "column",
                }}
              >
                <DotLoader color={"#000000"} loading={true} size={50} />
                <br />
                <br />
                <span
                  style={{
                    fontFamily: "Helvetica, sans-serif",
                    color: "#353232",
                    width: "50%",
                    lineHeight: "1.5",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#353232",
                      fontSize: "20px",
                      textAlign: "center",
                    }}
                  >
                    your
                  </span>
                  <br />
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#00ba75",
                      fontSize: "20px",
                    }}
                  >
                    kila
                  </span>
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#008ad0",
                      fontSize: "20px",
                    }}
                  >
                    day
                  </span>
                  .
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#FF0000",
                      fontSize: "20px",
                    }}
                  >
                    every
                  </span>
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#FF0000",
                      fontSize: "20px",
                    }}
                  >
                    thing
                  </span>
                  . app!
                  <br />
                  <br />
                </span>
              </div>
            );
          }}
        />
        <Route
          path="/little"
          component={() => {
            window.location.href = "https://little.bz/app/";
            return <div>Loading...</div>;
          }}
        />
        <Route
          path="/vercel"
          component={() => {
            window.location.href = "https://littleafrica.vercel.app/app";
            return <div>Loading...</div>;
          }}
        />
        <Route
          path="/driver"
          component={() => {
            if (isAndroid) {
              window.location.href =
                "https://play.google.com/store/apps/details?id=com.craftsilicon.littlecabdriver";
            }
            if (isIOS) {
              window.location.href =
                "https://apps.apple.com/ke/app/little-agent/id1547421613";
            }
            if (isDesktop) {
              window.location.href =
                "https://play.google.com/store/apps/details?id=com.craftsilicon.littlecabdriver";
            }
            return (
              <div
                style={{
                  marginTop: "170px",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  flexDirection: "column",
                }}
              >
                <DotLoader color={"#000000"} loading={true} size={50} />
                <br />
                <br />
                <span
                  style={{
                    fontFamily: "Helvetica, sans-serif",
                    color: "#353232",
                    width: "50%",
                    lineHeight: "1.5",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#353232",
                      fontSize: "20px",
                      textAlign: "center",
                    }}
                  >
                    your
                  </span>
                  <br />
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#00ba75",
                      fontSize: "20px",
                    }}
                  >
                    kila
                  </span>
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#008ad0",
                      fontSize: "20px",
                    }}
                  >
                    day
                  </span>
                  .
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#FF0000",
                      fontSize: "20px",
                    }}
                  >
                    every
                  </span>
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#FF0000",
                      fontSize: "20px",
                    }}
                  >
                    thing
                  </span>
                  . app!
                  <br />
                  <br />
                </span>
              </div>
            );
          }}
        />
        <Route
          path="/app"
          component={() => {
            if (isAndroid) {
              window.location.href =
                "https://play.google.com/store/apps/details?id=com.craftsilicon.littlecabrider";
            }
            if (isIOS) {
              window.location.href =
                "https://apps.apple.com/ke/app/little-ride/id1130691846";
            }
            if (isDesktop) {
              window.location.href = "https://apps.little.africa/";
            }
            return (
              <div
                style={{
                  marginTop: "170px",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  flexDirection: "column",
                }}
              >
                <DotLoader color={"#000000"} loading={true} size={50} />
                <br />
                <br />
                <span
                  style={{
                    fontFamily: "Helvetica, sans-serif",
                    color: "#353232",
                    width: "50%",
                    lineHeight: "1.5",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#353232",
                      fontSize: "20px",
                      textAlign: "center",
                    }}
                  >
                    your
                  </span>
                  <br />
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#00ba75",
                      fontSize: "20px",
                    }}
                  >
                    kila
                  </span>
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#008ad0",
                      fontSize: "20px",
                    }}
                  >
                    day
                  </span>
                  .
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#FF0000",
                      fontSize: "20px",
                    }}
                  >
                    every
                  </span>
                  <span
                    style={{
                      fontFamily: "Helvetica, sans-serif",
                      color: "#FF0000",
                      fontSize: "20px",
                    }}
                  >
                    thing
                  </span>
                  . app!
                  <br />
                  <br />
                </span>
              </div>
            );
          }}
        />
        <Route
          path="/supplyleads"
          component={() => {
            window.location.href =
              "https://docs.google.com/forms/d/e/1FAIpQLScM-N1FEFMxxlp7norybdhssle6rbs0tIgj9mEYVZXk-0zdSw/alreadyresponded";
            return null;
          }}
        />

        {/* Explicit handlers for Britam document routes - case insensitive */}
        <Route
          exact
          path="/britam"
          render={() => <Redirect to="/ke/britam" />}
        />
        <Route
          exact
          path="/Britam"
          render={() => <Redirect to="/ke/britam" />}
        />
        <Route
          exact
          path="/britam.pdf"
          render={() => <Redirect to="/ke/britam" />}
        />
        <Route
          exact
          path="/Britam.pdf"
          render={() => <Redirect to="/ke/britam" />}
        />
        <Route
          exact
          path="/britamtz"
          render={() => <Redirect to="/tz/britam" />}
        />
        <Route
          exact
          path="/Britamtz"
          render={() => <Redirect to="/tz/britam" />}
        />
        <Route
          exact
          path="/britamtz.pdf"
          render={() => <Redirect to="/tz/britam" />}
        />
        <Route
          exact
          path="/Britamtz.pdf"
          render={() => <Redirect to="/tz/britam" />}
        />

        {/* Britam Personal Accident document routes */}
        <Route
          exact
          path="/ke/britam/Personal-Accident"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/ke/britam/personal-accident"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/ke/britam/Personal-Accident.pdf"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/ke/britam/personal-accident.pdf"
          component={DocumentRenderer}
        />

        {/* PA Life Cover document routes - new path structure */}
        <Route
          exact
          path="/ke/insurance/pa-lifecover"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/ke/insurance/PA-LIFECOVER"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/ke/insurance/pa-lifecover.pdf"
          component={DocumentRenderer}
        />

        {/* Legacy PA Life Cover routes - redirect to new path */}
        <Route
          exact
          path="/pa-lifecover"
          render={() => <Redirect to="/ke/insurance/pa-lifecover" />}
        />
        <Route
          exact
          path="/PA-LIFECOVER"
          render={() => <Redirect to="/ke/insurance/pa-lifecover" />}
        />
        <Route
          exact
          path="/pa-lifecover.pdf"
          render={() => <Redirect to="/ke/insurance/pa-lifecover" />}
        />

        {/* Legacy HealthX Customer Journey routes - redirect to main path */}
        <Route
          exact
          path="/customer-journey"
          render={() => <Redirect to="/healthx/customer-journey" />}
        />
        <Route
          exact
          path="/Customer-Journey"
          render={() => <Redirect to="/healthx/customer-journey" />}
        />
        <Route
          exact
          path="/customer-journey.html"
          render={() => <Redirect to="/healthx/customer-journey" />}
        />

        {/* Legacy HealthX Terms & Conditions routes - redirect to main path */}
        <Route
          exact
          path="/terms"
          render={() => <Redirect to="/healthx/terms" />}
        />
        <Route
          exact
          path="/Terms"
          render={() => <Redirect to="/healthx/terms" />}
        />
        <Route
          exact
          path="/terms.html"
          render={() => <Redirect to="/healthx/terms" />}
        />

        {/* PA-LIFECOVER.pdf route */}

        {/* Britam-Absa document routes */}
        <Route
          exact
          path="/ke/Absa/Britam-Absa"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/ke/Absa/Britam-Absa.pdf"
          component={DocumentRenderer}
        />

        {/* Mfanisi GO document routes */}
        <Route
          exact
          path="/ke/maishapoa/mfanisi"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/ke/maishapoa/Mfanisi"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/ke/maishapoa/mfanisi.pdf"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/ke/maishapoa/Mfanisi.pdf"
          component={DocumentRenderer}
        />

        {/* HealthX Customer Journey document routes */}
        <Route
          exact
          path="/healthx/customer-journey"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/healthx/Customer-Journey"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/ke/healthx/customer-journey"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/ke/healthx/Customer-Journey"
          component={DocumentRenderer}
        />

        {/* HealthX Terms & Conditions document routes */}
        <Route
          exact
          path="/healthx/terms"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/healthx/Terms"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/ke/healthx/terms"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/ke/healthx/Terms"
          component={DocumentRenderer}
        />

        {/* Document routes with country handling - order is important */}
        <Route exact path="/documents/*" component={DocumentRenderer} />
        <Route
          exact
          path="/:country/:folderName/:documentName"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/:country/:folderName/:documentName.pdf"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/:country/:documentName"
          component={DocumentRenderer}
        />
        <Route
          exact
          path="/:country/:documentName.pdf"
          component={DocumentRenderer}
        />

        {/* Country route comes before document redirector */}
        <Route exact path="/:country" component={Home} />

        {/* Document redirector routes - redirect to country-specific path */}
        <Route exact path="/:documentName" component={DocumentRedirector} />
        <Route exact path="/:documentName.pdf" component={DocumentRedirector} />
          </Switch>
        </LanguageProvider>
      </GeoRedirectWrapper>
    </GeolocationProvider>
  );
}
export default App;
